"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFlex = exports.getFlex = exports.extractFlex = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const flexKeys = [
    'flexDirection',
    'justifyContent',
    'alignItems',
    'flexWrap',
    'alignContent',
    'order',
    'flexGrow',
    'flexShrink',
    'flexBasis',
    'flex',
    'alignSelf',
];
const extractFlex = (props) => (0, StyledFunctions_1.extractPropsByKeys)(props, flexKeys);
exports.extractFlex = extractFlex;
const getFlex = (props) => (0, StyledFunctions_1.getCSS)(props, flexKeys);
exports.getFlex = getFlex;
const Flex = styled_components_1.default.div `
  display: ${props => (props.inline ? 'inline-flex' : 'flex')};
  ${exports.getFlex};
  ${StyledFunctions_1.getMargin};
  ${StyledFunctions_1.getPadding};
`;
exports.LinkFlex = styled_components_1.default.a `
  display: ${props => (props.inline ? 'inline-flex' : 'flex')};
  ${exports.getFlex};
  ${StyledFunctions_1.getMargin};
  ${StyledFunctions_1.getPadding};
`;
exports.default = Flex;
